import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    affiliators: [],
    affiliator: {},
    affiliatorDeleted: {},
    paginator: [],
    exportRoute: '',
    loading: false,
    errorMsg: '',
    errors: {}
};

const affiliatorSlice = createSlice({
    name: 'affiliators',
    initialState,
    reducers: {
        setAffiliators: (state, action) => {
            state.affiliators = action.payload;
        },
        setAffiliator: (state, action) => {
            state.affiliator = action.payload;
        },
        setAffiliatorDeleted: (state, action) => {
            state.affiliatorDeleted = action.payload;
        },
        setPaginator: (state, action) => {
            state.paginator = action.payload;
        },
        setExportRoute: (state, action) => {
            state.exportRoute = action.payload;
        },
        getErrors: (state, action) => {
            state.errorMsg = action.payload.errorMsg;
            state.errors = action.payload.errors;
        },
        clearErrors: (state) => {
            state.errorMsg = '';
            state.errors = '';
        },
        loading: (state, action) => {
            state.loading = action.payload;
        }
    },
});

export const { loading, setAffiliators, setAffiliator, setAffiliatorDeleted, setPaginator, setExportRoute, clearErrors, getErrors } = affiliatorSlice.actions;
export default affiliatorSlice.reducer;
